module.exports = __webpack_public_path__ + "img/568-42dfb3.png";